export enum WorkSheetStartingRow {
    DOUBLE = 'DOUBLE',
    OUTSIDE = 'OUTSIDE',
    ANY = 'N/A'
}
